import React from 'react'

const IconSvg = ({
  color = 'black',
  opacity = 1,
  ...props
}: {
  color?: string
  opacity?: number
  [x: string]: any
}) => (
  <svg
    width='15'
    height='15'
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    opacity={opacity}
    {...props}
  >
    <path
      d='M10 0.625H5C3.9625 0.625 3.125 1.4625 3.125 2.5V12.5C3.125 13.5375 3.9625 14.375 5 14.375H10C11.0375 14.375 11.875 13.5375 11.875 12.5V2.5C11.875 1.4625 11.0375 0.625 10 0.625ZM8.75 13.125H6.25V12.5H8.75V13.125ZM10.7812 11.25H4.21875V2.5H10.7812V11.25Z'
      fill={color}
    />
  </svg>
)

export default IconSvg
